import React from 'react';
import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import styles from './Header.scss';
import analytics from '../../services/analytics';

const EditorExpandButton = ({ theme, editorExpand, toggleExpand }) => {
  const isDarkTheme = theme === 'vs-dark';

  const handleToggle = () => {
    if (editorExpand) {
      analytics.trackFullscreenDisabled();
    } else {
      analytics.trackFullscreenEnabled();
    }
    toggleExpand();
  };

  return (
    <div
      className={classNames({
        [styles['expand-btn']]: true,
        [styles['expand-btn-dark']]: isDarkTheme,
      })}
      style={{
        cursor: 'pointer',
        border: 'none',
        background: 'none',
        color: isDarkTheme ? 'white' : '#1890FF',
      }}
      onClick={handleToggle}
      title={editorExpand ? 'Restore Editor' : 'Maximize Editor'}
    >
      {editorExpand ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
    </div>
  );
};

export default EditorExpandButton;
